import { CartLinesUpdateEvent } from '@shopify/events';

let additionPending = false;
const cartRoot = window.Shopify?.routes?.root || '/';

class VmfOrderBumps extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.addEventListener('click', this.changeComplement, { signal: this.controller.signal });
    this.addEventListener('submit', this.addComplement, { signal: this.controller.signal });
    this.addEventListener('change', this.updatePrice, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
  changeComplement = (event) => {
    const control = event.target.closest('[data-vmf-direction]');
    if (!control) return;
    const cards = [...this.querySelectorAll('.vmf-bump-card')];
    const current = Math.max(0, cards.findIndex(card => !card.hidden));
    const next = (current + Number(control.dataset.vmfDirection) + cards.length) % cards.length;
    cards.forEach((card, index) => { card.hidden = index !== next; });
    this.querySelector('[data-vmf-position]').textContent = `${next + 1} / ${cards.length}`;
  };
  updatePrice = (event) => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement)) return;
    const price = select.closest('form')?.querySelector('[data-vmf-bump-price]');
    if (price) price.textContent = select.selectedOptions[0]?.dataset.price || '';
    const quantity = select.form?.elements.namedItem('quantity');
    if (quantity) quantity.value = select.selectedOptions[0]?.dataset.minimum || '1';
  };
  addComplement = async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-vmf-bump-form]')) return;
    event.preventDefault();
    event.stopPropagation();
    if (additionPending) return;
    additionPending = true;
    const button = form.querySelector('button[type="submit"]');
    const status = this.querySelector('[data-vmf-bump-status]');
    const variantControl = form.elements.namedItem('id');
    const variant = variantControl instanceof HTMLSelectElement ? variantControl.selectedOptions[0] : variantControl;
    const quantity = Math.max(1, Number(variant?.dataset.minimum) || 1);
    const id = Number(variantControl?.value);
    if (!Number.isSafeInteger(id) || id <= 0) { additionPending = false; return; }
    document.querySelectorAll('[data-vmf-bump-form] button').forEach(el => { el.disabled = true; });
    button.textContent = 'Agregando…';
    status.textContent = '';
    const deferred = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product', lines: [{ merchandiseId: String(id), quantity }], promise: deferred.promise,
    }));
    let added = false;
    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(`${cartRoot}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity }], sections, sections_url: location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'No pudimos agregar este producto. Revisa su disponibilidad e inténtalo de nuevo.');
      added = true;
      const cartResponse = await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('El producto se agregó. Abre el carrito para consultar el total actualizado.');
      const cart = await cartResponse.json();
      const message = `${button.dataset.productTitle} se agregó a tu carrito.`;
      const announcement = document.querySelector('[data-vmf-cart-announcement]');
      if (announcement) announcement.textContent = message;
      status.textContent = message;
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { items: cart.items, source: 'vmf-order-bump', sourceId: this.id || 'vmf-order-bumps', itemCount: quantity, sections: result.sections, didError: false },
      });
    } catch (error) {
      status.textContent = error.message || 'No pudimos actualizar el carrito. Inténtalo de nuevo.';
      if (added) {
        const link = document.createElement('a');
        link.href = `${cartRoot}cart`;
        link.textContent = ' Ver mi carrito';
        status.append(link);
      }
      try {
        const response = await fetch(`${cartRoot}cart.js`, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (cart.items.some(item => Number(item.variant_id) === id)) {
          added = true;
          status.textContent = 'El producto está en tu carrito.';
        }
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { didError: !added, source: 'vmf-order-bump' } });
      } catch (refreshError) { deferred.reject(refreshError); }
    } finally {
      additionPending = false;
      document.querySelectorAll('[data-vmf-bump-form] button').forEach(el => { el.disabled = false; });
      if (added && button.isConnected) { button.textContent = 'Agregado ✓'; button.disabled = true; }
      else if (button.isConnected) button.textContent = 'Agregar +';
    }
  };
}
if (!customElements.get('vmf-order-bumps')) customElements.define('vmf-order-bumps', VmfOrderBumps);
